import { render, staticRenderFns } from "./ProductsTablev2.vue?vue&type=template&id=4b493bf2&scoped=true"
import script from "./ProductsTablev2.vue?vue&type=script&lang=js"
export * from "./ProductsTablev2.vue?vue&type=script&lang=js"
import style0 from "./ProductsTablev2.vue?vue&type=style&index=0&id=4b493bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b493bf2",
  null
  
)

export default component.exports